import Square from '@/components/order/elements/payments/integration/Square'
import Stripe from '@/components/order/elements/payments/integration/Stripe'
// import SumUp from '@/components/order/elements/payments/integration/SumUp.vue'


export default {
  [Square.guid]: Square,
  [Stripe.guid]: Stripe,
  // [SumUp.guid]: SumUp
}
